import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { apiPath } from '@/constants/defaultValues';
import { Post, Put } from '@/api/api-middleware';
import { getLabel } from '@/helpers/Utils';

const initialState = {
  employeeCategoryList: [],
  qualificationTypeList: [],
  qualificationList: [],
  reasonList: [],
  cardTypeList: [],
  qualificationStatusList: [],
  qualificationEquivalenceList: [],
  appraisalFinalResultList: [],
  countryList: [],
  promotionTypeList: [],
  companyList: [],
  genderList: [],
  currentType: 0,
  loading: false,
  error: '',
};
export const fetchEmployeeLookups = createAsyncThunk(
  'employeeLookups/fetchEmployeeLookups',
  async ({ currentType, ...params }, thunkAPI) => {
    try {
      const response = await Lookup.GetEmployeeLookups(currentType);
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: item.name,
          value: item.id,
          key: item.id,
          code: item.code,
          isDefaultValue: item?.isDefaultValue,
          categoryID: item?.categoryID || '',
        })) ?? [];
      return { currentType, data: [firstListItem, ...mappedData] };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const employeeLookupSlice = createSlice({
  name: 'employeeLookups',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeLookups.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeLookups.fulfilled, (state, action) => {
        state.loading = false;
        const { currentType, data } = action.payload;
        state.currentType = currentType;

        if (currentType === 1) state.employeeCategoryList = data;
        else if (currentType === 2) state.qualificationTypeList = data;
        else if (currentType === 3) state.qualificationList = data;
        else if (currentType === 4) state.reasonList = data;
        else if (currentType === 5) state.cardTypeList = data;
        else if (currentType === 6) state.qualificationStatusList = data;
        else if (currentType === 7) state.qualificationEquivalenceList = data;
        else if (currentType === 8) state.appraisalFinalResultList = data;
        else if (currentType === 9) state.countryList = data;
        else if (currentType === 10) state.promotionTypeList = data;
        else if (currentType === 11) state.companyList = data;
        else if (currentType === 12) state.genderList = data;

        state.error = '';
      })
      .addCase(fetchEmployeeLookups.rejected, (state, action) => {
        state.loading = false;
        if (state.currentType === 1) state.employeeCategoryList = [];
        else if (state.currentType === 2) state.qualificationTypeList = [];
        else if (state.currentType === 3) state.qualificationList = [];
        else if (state.currentType === 4) state.reasonList = [];
        else if (currentType === 5) state.cardTypeList = [];
        else if (currentType === 6) state.qualificationStatusList = [];
        else if (currentType === 7) state.qualificationEquivalenceList = [];
        else if (currentType === 8) state.appraisalFinalResultList = [];
        else if (currentType === 9) state.countryList = [];
        else if (currentType === 10) state.promotionTypeList = [];
        else if (currentType === 11) state.companyList = data;
        else if (currentType === 12) state.genderList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default employeeLookupSlice.reducer;
